import { Steps, StepStatus } from "@/constants/analysis-status/index";

export default class AnalysisStatusIcons {
  public static fromText(analysisStatus: string, step: string) {
    if (step === Steps.SUMMARY && analysisStatus === StepStatus.FINISHED) {
        return StepStatus.FINISHED.toLocaleLowerCase();
    }
    
    switch (analysisStatus) {
      case StepStatus.PROCESSING: {
        return StepStatus.PROCESSING.toLocaleLowerCase();
      }
      case StepStatus.ERROR: {
        return StepStatus.ERROR.toLocaleLowerCase();
      }
      default: {
        return StepStatus.PROCESSING.toLocaleLowerCase();
      }
    }
  }
}
